// Width of the web shopping-assistant side panel, in pixels. Shared (via
// useShoppingAssistantViewport) by the panel itself and the layout page-squeeze
// so the two can never drift.
export const ASSISTANT_PANEL_WIDTH_PX = 375

// Trailing debounce (ms) applied after the last structured-data registration
// before pushing browsing context, to absorb a reactive useHead getter
// re-firing shortly after page:finish (e.g. the PDP's multi-ref Product schema).
export const BROWSING_CONTEXT_DEBOUNCE_MS = 200

// Extra desktop-only clearance (px) that unrelated bottom-right popups (the
// TelcoPartner PDP popups, the lead-collection popup) add above their own
// position while the FAB is visible, so they don't render on top of it — see
// useShoppingAssistantPopupOffset. Estimated from the FAB's own padding/icon/
// text (not pixel-perfect design-validated).
export const ASSISTANT_FAB_CLEARANCE_OFFSET_PX = 84

export const SCROLL_CONTAINER_ATTRIBUTE = 'data-scroll-container'

// Name of the RevDialog listing past conversations, shared between the Header
// trigger button and the ChatHistory dialog itself.
export const CHAT_HISTORY_DIALOG_NAME = 'shopping-assistant-chat-history'

export const ENTRY_POINTS = [
  'product_page',
  'search',
  'floating_button',
  'seeded_link',
  'assisted_search',
  'pdp_pills',
  'keyboard_shortcut',
] as const
